import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const PaymentGatewayIntegrationLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'PaymentGatewayIntegration' */ './components')
);

export default (store) => {
	return {
		path: 'payment-gateway-integration',
		element: (
			<AsyncLoading
				component={
					<PaymentGatewayIntegrationLazy featureFlag="FeatureFlag:PaymentGatewayIntegration" />
				}
			/>
		),
	};
};
